import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const TimezoneContext = createContext(null);

const STORAGE_KEY = 'app-timezone-mode';

const readInitialMode = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'local';
  } catch {
    return 'local';
  }
};

export function TimezoneProvider({ children }) {
  const [mode, setModeState] = useState(readInitialMode);

  const setMode = useCallback((next) => {
    setModeState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore storage errors (quota / disabled storage)
    }
  }, []);

  const toggleMode = useCallback(() => {
    setMode(mode === 'local' ? 'utc' : 'local');
  }, [mode, setMode]);

  const value = useMemo(
    () => ({
      mode,
      setMode,
      toggleMode,
    }),
    [mode, setMode, toggleMode]
  );

  return <TimezoneContext.Provider value={value}>{children}</TimezoneContext.Provider>;
}

export function useTimezone() {
  const context = useContext(TimezoneContext);

  if (!context) {
    throw new Error('useTimezone must be used inside TimezoneProvider');
  }

  return context;
}
